// import React, { useEffect, useRef, useState } from "react";
// import styles from "./Settings.module.css";

// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/context/Auth";
// import SettingModal from "../../components/updatedComponents/Settings/SettingModal";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import {
//   CancelIcon2,
//   DeleteFile,
//   ManagerCameraIcon,
//   NewManagerCreateIcon,
// } from "../../components/icons/Icon";
// import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
// import RadioButtonGroup from "../../components/updatedComponents/FormComponents/RadioButtonGroup";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import { ModalWrapper } from "../../exports";
// import fetchData from "../../APIsControll/apiControll";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import Spinner from "../../components/updatedComponents/FormComponents/Spinner";
// import UrlInput from "../../components/updatedComponents/Settings/UrlInput";
// import { applyBranding, saveBranding } from "../../Utils/brandingManager";
// import { useBranding } from "../../components/context/BrandingContext";

// const REGEX = {
//   email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
//   mobile: /^[6-9]\d{9}$/, // Indian 10-digit mobile
//   gstuin: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
//   cin: /^[LUu][0-9]{5}[A-Za-z]{2}[0-9]{4}[A-Za-z]{3}[0-9]{6}$/,
//   websiteLink: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/,
//   pincode: /^[1-9][0-9]{5}$/,
//   // facebook: /^(https?:\/\/)?(www\.)?facebook\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   // instagram: /^(https?:\/\/)?(www\.)?instagram\.com(\/[A-Za-z0-9._-]+)?\/?$/,

//   // linkedin: /^(https?:\/\/)?(www\.)?linkedin\.com(\/[A-Za-z0-9._/-]+)?\/?$/,

//   // twitter: /^(https?:\/\/)?(www\.)?(x|twitter)\.com(\/[A-Za-z0-9_]+)?\/?$/,
// };

// const validateField = (name, value) => {
//   const str = value == null ? "" : String(value);
//   if (!str || str.trim() === "") return "";

//   // For optional fields (social media)
//   if (
//     name !== "websiteLink" &&
//     (!str || str === "https://" || str === "http://")
//   ) {
//     return "";
//   }
//   switch (name) {
//     case "email":
//       return REGEX.email.test(str) ? "" : "Enter a valid email address";
//     case "mobile":
//       return REGEX.mobile.test(str)
//         ? ""
//         : "Enter a valid 10-digit mobile number";
//     case "gstuin":
//       return REGEX.gstuin.test(str.toUpperCase())
//         ? ""
//         : "Enter a valid GSTIN/UIN (e.g. 22AAAAA0000A1Z5)";
//     case "cin":
//       return REGEX.cin.test(str)
//         ? ""
//         : "Enter a valid CIN (e.g. L17110MH1973PLC019786)";
//     // case "facebook":
//     //   return REGEX.facebook.test(str)
//     //     ? ""
//     //     : "Enter a valid Facebook URL (e.g. https://facebook.com/username)";

//     // case "instagram":
//     //   return REGEX.instagram.test(str)
//     //     ? ""
//     //     : "Enter a valid Instagram URL (e.g. https://instagram.com/username)";

//     // case "linkedin":
//     //   return REGEX.linkedin.test(str)
//     //     ? ""
//     //     : "Enter a valid LinkedIn URL (e.g. https://linkedin.com/in/username)";

//     // case "twitter":
//     //   return REGEX.twitter.test(str)
//     //     ? ""
//     //     : "Enter a valid X/Twitter URL (e.g. https://x.com/username)";
//     case "websiteLink":
//       return REGEX.websiteLink.test(str)
//         ? ""
//         : "Enter a valid URL (e.g. https://example.com)";
//     case "pincode":
//       return REGEX.pincode.test(str) ? "" : "Enter a valid 6-digit PIN code";
//     default:
//       return "";
//   }
// };

// const Settings = () => {
//   const { mode, managerId, setPaymentGatewayAccess, setSettingsData } =
//     useAuth();
//   const navigate = useNavigate();
//   const { setBranding } = useBranding();
//   const { show } = useToast();
//   const textColor = { color: mode ? "#ffffff" : "#646b88" };

//   const companyInputRef = useRef(null);
//   const pgInputRef = useRef(null);

//   const companyLogo = () => (
//     <svg
//       width="40"
//       height="40"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke={mode ? "#ffffff" : "#72788F"}
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <rect x="3" y="3" width="18" height="18" rx="2" />
//       <path d="M9 21V9h6v12" />
//     </svg>
//   );

//   const [errors, setErrors] = useState({});
//   const [previewImage, setPreviewImage] = useState(null);
//   const [logoFile, setLogoFile] = useState(null);
//   const [pgPreviewImage, setPgPreviewImage] = useState(null);
//   const [pgLogoFile, setPgLogoFile] = useState(null);
//   const [loadingData, setLoadingData] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [loadingAddress, setLoadingAddress] = useState(false);
//   const [modalContent, setModalContent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [refreshKey, setRefreshKey] = useState(0);
//   const [companyData, setCompanyData] = useState({
//     managerId: managerId,
//     companyLogo: "",
//     companyName: "",
//     projectId: "",
//     // companyShortName: "",
//     projectName: "",
//     email: "",
//     mobile: "",
//     gstuin: "",
//     cin: "",
//     // facebook: "",
//     // instagram: "",
//     // linkedin: "",
//     // twitter: "",
//     pincode: "",
//     street: "",
//     district: "",
//     city: "",
//     state: "",
//     country: "",
//     paymentGatewayAccess: false,
//     websiteLink: "",
//     paymentGatewayName: "",
//     paymentGatewayLogo: "",
//   });

//   // -------------------------------------

//   const DEFAULT_TITLE = "Admin";

//   const DEFAULT_FAVICON = "/favicon.png";

//   //  Reset branding
//   const resetBranding = () => {
//     localStorage.removeItem("branding");

//     // Reset browser branding
//     applyBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });

//     // Reset context branding
//     setBranding({
//       title: DEFAULT_TITLE,

//       favicon: DEFAULT_FAVICON,
//     });
//   };

//   // ---------------------------------------

//   useEffect(() => {
//     const getSettingsData = async () => {
//       setLoadingData(true);

//       try {
//         const res = await fetchData("admin/getSettings", {
//           managerId: managerId,
//         });

//         if (res.status === "success") {
//           const originalData = res.data[0];
//           setPaymentGatewayAccess(originalData.paymentGatewayAccess);
//           setSettingsData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             projectName: originalData.projectName,
//             websiteLink: originalData.paymentGatewayAccess
//               ? originalData.websiteLink
//               : "",
//           });
//           setCompanyData({
//             companyLogo: originalData.companyLogo,
//             companyName: originalData.companyName,
//             projectId: originalData.projectId,
//             // companyShortName: originalData.companyShortName,
//             projectName: originalData.projectName,
//             email: originalData.email,
//             mobile: originalData.mobile,
//             gstuin: originalData.gstuin,
//             cin: originalData.cin,
//             // facebook: originalData.facebook,
//             // instagram: originalData.instagram,
//             // linkedin: originalData.linkedin,
//             // twitter: originalData.twitter,
//             pincode: String(originalData.pincode || ""),
//             street: originalData.street,
//             district: originalData.district,
//             city: originalData.city,
//             state: originalData.state,
//             country: originalData.country,
//             paymentGatewayAccess: originalData.paymentGatewayAccess,
//             paymentGatewayName: originalData.paymentGatewayName,
//             paymentGatewayLogo: originalData.paymentGatewayLogo,
//             websiteLink: originalData.websiteLink,
//           });

//           setPreviewImage(
//             originalData.companyLogo
//               ? process.env.REACT_APP_S3URL + originalData.companyLogo
//               : null,
//           );

//           setPgPreviewImage(
//             originalData.paymentGatewayLogo
//               ? process.env.REACT_APP_S3URL + originalData.paymentGatewayLogo
//               : null,
//           );

//           const brandingData = {
//             //  Safe Title
//             title:
//               originalData?.projectName &&
//               originalData.projectName.trim() !== ""
//                 ? originalData.projectName
//                 : DEFAULT_TITLE,

//             //  Safe Logo
//             favicon:
//               originalData?.companyLogo &&
//               originalData.companyLogo.trim() !== ""
//                 ? process.env.REACT_APP_S3URL + originalData.companyLogo
//                 : DEFAULT_FAVICON,
//           };

//           //  Apply browser branding
//           applyBranding(brandingData);

//           //  Save localStorage branding
//           saveBranding(brandingData);

//           //  Update Context branding
//           setBranding(brandingData);
//         }
//         if (res?.status === "failed") {
//           resetBranding();
//           // show(res?.msg, "error");
//           localStorage.removeItem("settingsData");
//           setSettingsData({
//             companyLogo: "",
//             companyName: "",
//             paymentGatewayAccess: false,
//             projectName: "",
//             websiteLink: "",
//           });
//         }
//       } catch (error) {
//         resetBranding();
//         console.error("Error fetching Settings data:", error);
//       } finally {
//         setLoadingData(false);
//       }
//     };

//     if (managerId) {
//       getSettingsData();
//     }
//   }, [managerId, refreshKey]);

//   const handleFieldChange = (field, value) => {
//     setCompanyData((prev) => ({ ...prev, [field]: value }));
//     const err = validateField(field, value);
//     setErrors((prev) => ({ ...prev, [field]: err }));
//   };

//   const handlePhotoClick = (ref) => {
//     ref.current.click();
//   };

//   const handleDrop = (e, type) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files[0];
//     handleFile(file, type);
//   };

//   const handleDragOver = (e) => {
//     e.preventDefault();
//   };

//   const handleFile = (file, type) => {
//     if (file && file.type.startsWith("image/")) {
//       const imageUrl = URL.createObjectURL(file);
//       if (type === "company") {
//         setPreviewImage(imageUrl);
//         setLogoFile(file);
//       } else if (type === "pg") {
//         setPgPreviewImage(imageUrl);
//         setPgLogoFile(file);
//       }
//     }
//   };

//   const handlePhotoChange = (event, type) => {
//     const file = event.target.files[0];
//     handleFile(file, type);
//   };

//   const handleRemoveLogo = (type) => {
//     if (type === "company") {
//       setPreviewImage(null);
//       setLogoFile(null);
//       companyInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, companyLogo: "" }));
//     } else if (type === "pg") {
//       setPgPreviewImage(null);
//       setPgLogoFile(null);
//       pgInputRef.current.value = "";
//       setCompanyData((prev) => ({ ...prev, paymentGatewayLogo: "" }));
//     }
//   };

//   const createSettingsData = async () => {
//     setLoading(true);
//     const cleanUrl = (url) => {
//       const str = (url || "").trim();

//       return str === "https://" || str === "http://" ? "" : str;
//     };

//     try {
//       const formData = new FormData();
//       formData.append("managerId", managerId);
//       formData.append("companyName", companyData.companyName);
//       formData.append("projectName", companyData.projectName);
//       // formData.append("companyShortName", companyData.companyShortName);
//       formData.append("email", companyData.email);
//       formData.append("mobile", companyData.mobile || "");
//       formData.append("gstuin", companyData.gstuin);
//       formData.append("cin", companyData.cin);
//       // formData.append("facebook", cleanUrl(companyData.facebook));
//       // formData.append("instagram", cleanUrl(companyData.instagram));
//       // formData.append("linkedin", cleanUrl(companyData.linkedin));
//       // formData.append("twitter", cleanUrl(companyData.twitter));
//       formData.append("pincode", companyData.pincode);
//       formData.append("street", companyData.street);
//       formData.append("district", companyData.district);
//       formData.append("city", companyData.city);
//       formData.append("state", companyData.state);
//       formData.append("country", companyData.country);
//       formData.append("paymentGatewayAccess", companyData.paymentGatewayAccess);
//       formData.append("paymentGatewayName", companyData.paymentGatewayName);
//       formData.append(
//         "websiteLink",
//         companyData.paymentGatewayAccess ? companyData.websiteLink : "",
//       );
//       if (companyData.projectId) {
//         formData.append("projectId", companyData.projectId);
//       }
//       if (logoFile) {
//         formData.append("companyLogo", logoFile);
//       }
//       if (pgLogoFile) {
//         formData.append("paymentGatewayLogo", pgLogoFile);
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_URL}admin/addUpSettings`,
//         {
//           method: "POST",
//           headers: {
//             "wa-platform": process.env.REACT_APP_ADMIN_SECRET,
//           },
//           body: formData,
//         },
//       );

//       const res = await response.json();

//       if (res.status === "success") {
//         show(res.msg, "success");

//         // applyBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         // saveBranding({
//         //   title: companyData.projectName,
//         //   favicon: companyData.companyLogo
//         //     ? process.env.REACT_APP_S3URL + companyData.companyLogo
//         //     : null,
//         // });

//         handleCloseModal();
//         setRefreshKey((prev) => prev + 1);
//       } else {
//         show(res.msg, "error");
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenModal = (content) => {
//     setModalContent(content);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const openSettingsData = () => {
//     const newErrors = {};

//     // Required field
//     if (!companyData.companyName) {
//       newErrors.companyName = "Company name is required";
//     }
//     if (!companyData.projectName) {
//       newErrors.projectName = "Project name is required";
//     }
//     // if (!companyData.companyShortName) {
//     //   newErrors.companyShortName = "Company Short name is required";
//     // }

//     if (companyData.paymentGatewayAccess) {
//       if (!companyData.websiteLink) {
//         newErrors.websiteLink = "Website Link is required";
//       }
//     }
//     if (!companyData.paymentGatewayName) {
//       newErrors.paymentGatewayName = "Payment Gateway name is required";
//     }

//     const formatFields = [
//       "email",
//       "mobile",
//       "gstuin",
//       "cin",
//       // "facebook",
//       // "instagram",
//       // "linkedin",
//       // "twitter",
//       "pincode",
//     ];
//     formatFields.forEach((field) => {
//       const err = validateField(field, companyData[field]);
//       if (err) newErrors[field] = err;
//     });

//     if (companyData.paymentGatewayAccess) {
//       const err = validateField("websiteLink", companyData.websiteLink);
//       if (err) newErrors.websiteLink = err;
//     }

//     setErrors(newErrors);
//     if (Object.keys(newErrors).length) return;

//     const isUpdate = !!companyData?.projectId;

//     handleOpenModal(
//       <SettingModal
//         heading={`${isUpdate ? "Update" : "Save"} Settings`}
//         centerHeading={`Are you sure you want to ${isUpdate ? "Update" : "Save"}?`}
//         subHeading={`To confirm! type ${isUpdate ? "update" : "save"} in the text field.`}
//         targetWord={isUpdate ? "update" : "save"}
//         handleSubmit={createSettingsData}
//         handleCloseModal={handleCloseModal}
//         focus
//       />,
//     );
//   };

//   useEffect(() => {
//     if (String(companyData.pincode).length === 6) {
//       setLoadingAddress(true);

//       let myHeaders = new Headers();
//       myHeaders.append("wa-platform", process.env.REACT_APP_ADMIN_SECRET);
//       myHeaders.append("Content-Type", "application/json");

//       let raw = JSON.stringify({ keyword: companyData.pincode });

//       fetch(process.env.REACT_APP_URL + "locations/locations", {
//         method: "POST",
//         headers: myHeaders,
//         body: raw,
//       })
//         .then((res) => res.json())
//         .then((result) => {
//           if (result.status === "success") {
//             setCompanyData((prev) => ({
//               ...prev,
//               district: result.SubDistName?.[0]?.toUpperCase() || "",
//               city: result.districts?.[0] || "",
//               state: result.states?.[0] || "",
//               country: "India",
//             }));
//           }
//         })
//         .catch(() => {})
//         .finally(() => {
//           setLoadingAddress(false);
//         });
//     }
//   }, [companyData.pincode]);

//   const PayGetwayOptions = [
//     { label: "Yes", value: true },
//     { label: "No", value: false },
//   ];

//   // console.log(companyData);

//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       <ModalWrapper isOpen={isModalOpen} onClose={handleCloseModal} noBtn>
//         {modalContent}
//       </ModalWrapper>

//       {loadingData ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//           }}
//           className={styles.nm_form}
//         >
//           <Spinner size="15" />
//         </div>
//       ) : (
//         <>
//           <div className={styles.topBar}>
//             <TopTabBar text={"Settings"} />
//           </div>

//           <div className={styles.nm_form}>
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Company Details
//                 </p>
//                 <h3 className={styles.sectionTitle}>Company Logo</h3>
//                 <div
//                   className={styles.nm_photo}
//                   onClick={() => handlePhotoClick(companyInputRef)}
//                   onDrop={(e) => handleDrop(e, "company")}
//                   onDragOver={handleDragOver}
//                 >
//                   {!previewImage ? (
//                     <div className={styles.upload_placeholder}>
//                       {companyData?.companyName?.charAt(0)?.toUpperCase() ||
//                         companyLogo()}
//                     </div>
//                   ) : (
//                     <img
//                       src={previewImage}
//                       alt="Company Logo"
//                       onError={() => setPreviewImage(null)}
//                       style={{
//                         filter: !mode ? "brightness(0) saturate(100%)" : "none",
//                       }}
//                     />
//                   )}
//                   {!previewImage ? (
//                     <div className={styles.nm_camera_icon}>
//                       <ManagerCameraIcon />
//                     </div>
//                   ) : (
//                     <div
//                       className={styles.remove_logo_btn}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleRemoveLogo("company");
//                       }}
//                     >
//                       <DeleteFile color={"#F93E3E"} />
//                     </div>
//                   )}
//                   <input
//                     type="file"
//                     ref={companyInputRef}
//                     style={{ display: "none" }}
//                     onChange={(e) => handlePhotoChange(e, "company")}
//                     accept="image/*"
//                   />
//                 </div>
//                 {errors.companyLogo && (
//                   <span className={styles.error}>{errors.companyLogo}</span>
//                 )}

//                 <div className={styles.element}>
//                   <InputTag
//                     name="companyName"
//                     value={companyData.companyName}
//                     labelText={"Company Name"}
//                     placeholderText={"Enter company name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyName && (
//                     <span className={styles.error}>{errors.companyName}</span>
//                   )}
//                 </div>

//                 {/* <div className={styles.element}>
//                   <InputTag
//                     name="companyShortName"
//                     value={companyData.companyShortName}
//                     labelText={"Short Name"}
//                     placeholderText={"Enter company name in short"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={9}
//                     star
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         companyShortName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.companyShortName && (
//                     <span className={styles.error}>
//                       {errors.companyShortName}
//                     </span>
//                   )}
//                 </div> */}

//                 <div className={styles.element}>
//                   <InputTag
//                     name="projectName"
//                     value={companyData.projectName}
//                     labelText={"Project Name"}
//                     placeholderText={"Enter project name"}
//                     placeholderType={"text"}
//                     required={true}
//                     star
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         projectName: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.projectName && (
//                     <span className={styles.error}>{errors.projectName}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="street"
//                     value={companyData.street}
//                     labelText={"Street Address"}
//                     placeholderText={"Enter street address"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         street: e.target.value,
//                       }))
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.street && (
//                     <span className={styles.error}>{errors.street}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="pincode"
//                     labelText={"PIN Code"}
//                     placeholderType="number"
//                     placeholderText="Enter Pincode"
//                     value={companyData.pincode}
//                     onChange={(e) => {
//                       const value = e.target.value;
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         pincode: value,
//                         city: "",
//                         state: "",
//                         district: "",
//                         country: "",
//                       }));
//                       setErrors((prev) => ({
//                         ...prev,
//                         pincode: validateField("pincode", value),
//                       }));
//                     }}
//                     maxLength={6}
//                     required={true}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.pincode && !loadingAddress && !companyData.city && (
//                     <span className={styles.error}>{errors.pincode}</span>
//                   )}
//                   {loadingAddress && (
//                     <p className={styles.loadingText} style={textColor}>
//                       Loading address
//                     </p>
//                   )}
//                   {!loadingAddress && companyData.city && (
//                     <p className={styles.addressText} style={textColor}>
//                       {companyData.district}, {companyData.city},{" "}
//                       {companyData.state}, {companyData.country}
//                     </p>
//                   )}
//                 </div>

//                 {/* ── Email ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="email"
//                     value={companyData.email}
//                     labelText={"Email"}
//                     placeholderText={"Enter email"}
//                     placeholderType={"email"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) => handleFieldChange("email", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.email && (
//                     <span className={styles.error}>{errors.email}</span>
//                   )}
//                 </div>

//                 {/* ── Mobile ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="mobile"
//                     value={companyData.mobile}
//                     labelText={"Mobile"}
//                     placeholderText={"Enter mobile"}
//                     placeholderType={"number"}
//                     required={true}
//                     maxLength={10}
//                     onChange={(e) =>
//                       handleFieldChange("mobile", e.target.value)
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.mobile && (
//                     <span className={styles.error}>{errors.mobile}</span>
//                   )}
//                 </div>

//                 {/* ── GSTIN/UIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="gstuin"
//                     value={companyData.gstuin}
//                     labelText={"GSTIN/UIN"}
//                     placeholderText={"Enter GSTIN/UIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={15}
//                     onChange={(e) =>
//                       handleFieldChange("gstuin", e.target.value.toUpperCase())
//                     }
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.gstuin && (
//                     <span className={styles.error}>{errors.gstuin}</span>
//                   )}
//                 </div>

//                 {/* ── CIN ── */}
//                 <div className={styles.element}>
//                   <InputTag
//                     name="cin"
//                     value={companyData.cin}
//                     labelText={"CIN"}
//                     placeholderText={"Enter CIN"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={21}
//                     onChange={(e) => handleFieldChange("cin", e.target.value)}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.cin && (
//                     <span className={styles.error}>{errors.cin}</span>
//                   )}
//                 </div>

//                 {/* --------Social Url-------- */}
//                 {/* <div className={styles.element}>
//                   <UrlInput
//                     name="facebook"
//                     value={companyData.facebook}
//                     labelText={"Facebook"}
//                     placeholder={"facebook.com/username"}
//                     placeholderText={"Enter facebook Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("facebook", e.target.value)
//                     }
//                   />
//                   {errors.facebook && (
//                     <span className={styles.error}>{errors.facebook}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="instagram"
//                     value={companyData.instagram}
//                     labelText={"Instagram"}
//                     placeholder={"instagram.com/username"}
//                     placeholderText={"Enter instagram Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("instagram", e.target.value)
//                     }
//                   />
//                   {errors.instagram && (
//                     <span className={styles.error}>{errors.instagram}</span>
//                   )}
//                 </div>

//                 <div className={styles.element}>
//                   <UrlInput
//                     name="linkedin"
//                     value={companyData.linkedin}
//                     labelText={"Linkedin"}
//                     placeholder={"linkedin.com/in/username"}
//                     placeholderText={"Enter linkedin Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("linkedin", e.target.value)
//                     }
//                   />
//                   {errors.linkedin && (
//                     <span className={styles.error}>{errors.linkedin}</span>
//                   )}
//                 </div>
//                 <div className={styles.element}>
//                   <UrlInput
//                     name="twitter"
//                     value={companyData.twitter}
//                     labelText={"Twitter"}
//                     placeholder={"x.com/username"}
//                     placeholderText={"Enter twitter Link"}
//                     placeholderType={"text"}
//                     padding={"8px"}
//                     fontSize={"12px"}
//                     onChange={(e) =>
//                       handleFieldChange("twitter", e.target.value)
//                     }
//                   />
//                   {errors.twitter && (
//                     <span className={styles.error}>{errors.twitter}</span>
//                   )}
//                 </div> */}
//               </div>
//             </div>

//             {/* --------------------- Features Section ---------------------------- */}
//             <div className={styles.nm_form_section}>
//               <div
//                 className={`${styles.inp_con} ${mode ? styles.inp_con_dark : ""}`}
//               >
//                 <p
//                   className={styles.wa_heading}
//                   style={{ color: mode ? "#ffffff" : "#72788F" }}
//                 >
//                   Features
//                 </p>
//                 <div className={styles.marketing}>
//                   <div className={styles.element_2}>
//                     <div className={styles.checkbox_sec}>
//                       <p style={{ color: mode && "#ffffff" }}>
//                         Payment Collection at External Website
//                       </p>
//                       <RadioButtonGroup
//                         key={companyData.paymentGatewayAccess}
//                         options={PayGetwayOptions}
//                         selectedOption={companyData.paymentGatewayAccess}
//                         onChange={(s) =>
//                           setCompanyData((prev) => ({
//                             ...prev,
//                             paymentGatewayAccess: s,
//                           }))
//                         }
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 {/* ── Website / Payment Gateway URL ── */}
//                 {companyData.paymentGatewayAccess && (
//                   <div className={styles.element}>
//                     <UrlInput
//                       name="websiteLink"
//                       value={companyData.websiteLink}
//                       labelText={"Website Link"}
//                       placeholder={"example.com"}
//                       placeholderText={"Enter Website Link"}
//                       placeholderType={"text"}
//                       padding={"8px"}
//                       fontSize={"12px"}
//                       onChange={(e) =>
//                         handleFieldChange("websiteLink", e.target.value)
//                       }
//                       star
//                     />
//                     {errors.websiteLink && (
//                       <span className={styles.error}>{errors.websiteLink}</span>
//                     )}
//                   </div>
//                 )}

//                 <h3 className={styles.sectionTitle}>Payment Gateway Logo</h3>

//                 <div className={styles.element}>
//                   <div
//                     className={styles.nm_photo}
//                     onClick={() => handlePhotoClick(pgInputRef)}
//                     onDrop={(e) => handleDrop(e, "pg")}
//                     onDragOver={handleDragOver}
//                   >
//                     {!pgPreviewImage ? (
//                       <div className={styles.upload_placeholder}>
//                         {companyData?.paymentGatewayName
//                           ?.charAt(0)
//                           ?.toUpperCase() || companyLogo()}
//                       </div>
//                     ) : (
//                       <img
//                         src={pgPreviewImage}
//                         alt="Logo"
//                         onError={() => setPgPreviewImage(null)}
//                         style={{
//                           filter: !mode
//                             ? "brightness(0) saturate(100%)"
//                             : "none",
//                         }}
//                       />
//                     )}

//                     {!pgPreviewImage ? (
//                       <div className={styles.nm_camera_icon}>
//                         <ManagerCameraIcon />
//                       </div>
//                     ) : (
//                       <div
//                         className={styles.remove_logo_btn}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handleRemoveLogo("pg");
//                         }}
//                       >
//                         <DeleteFile color={"#F93E3E"} />
//                       </div>
//                     )}

//                     <input
//                       type="file"
//                       ref={pgInputRef}
//                       style={{ display: "none" }}
//                       onChange={(e) => handlePhotoChange(e, "pg")}
//                       accept="image/*"
//                     />
//                   </div>
//                 </div>

//                 <div className={styles.element}>
//                   <InputTag
//                     name="paymentGatewayName"
//                     value={companyData.paymentGatewayName}
//                     labelText={"Payment Gateway Name"}
//                     placeholderText={"Enter Payment Gateway name"}
//                     placeholderType={"text"}
//                     required={true}
//                     maxLength={50}
//                     onChange={(e) =>
//                       setCompanyData((prev) => ({
//                         ...prev,
//                         paymentGatewayName: e.target.value,
//                       }))
//                     }
//                     star
//                     padding={"8px"}
//                     fontSize={"12px"}
//                   />
//                   {errors.paymentGatewayName && (
//                     <span className={styles.error}>
//                       {errors.paymentGatewayName}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </>
//       )}

//       <div
//         className={`${styles.nm_footer} ${mode ? styles.nm_footer_dark : ""}`}
//       >
//         <div className={styles.nm_footer_2}>
//           <Button
//             buttonIcon={<CancelIcon2 />}
//             buttonText={"CANCEL"}
//             buttonBgColor={"#000000"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => navigate(-1)}
//           />
//           <Button
//             buttonIcon={<NewManagerCreateIcon />}
//             buttonText={companyData?.projectId ? "Update" : "Save"}
//             buttonBgColor={"#4164E3"}
//             buttonTextColor={"#ffffff"}
//             buttonBorder={"none"}
//             buttonClick={() => openSettingsData()}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Settings;

// ----------------------- Work fine token settings -----------------------------

// import React, { useEffect, useState } from "react";

// import styles from "./Settings.module.css";

// import { useNavigate } from "react-router-dom";

// import { useAuth } from "../../components/context/Auth";

// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";

// import Company from "./Company";
// import Accounts from "./Accounts";
// import Voucher from "./Voucher";
// import Production from "./Production";

// import SettingsOtpVfy from "../../components/updatedComponents/Settings/SettingsOtpVfy";
// import fetchData from "../../APIsControll/apiControll";
// // import useDeviceInfo from "../../components/updatedComponents/Hooks/GetdeviceId";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";

// const Settings = () => {
//   const { mode, managerId } = useAuth();
//   const deviceId = localStorage.getItem("UnDeviceId");
//   const { show } = useToast();
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("company");

//   const [isVerified, setIsVerified] = useState(false);

//   const [otpActoken, setOtpAcToken] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [iPInfo, setIPInfo] = useState("");

//   // TABS

//   const TABS = [
//     {
//       id: "company",
//       label: "Company",
//     },
//     {
//       id: "accounts",
//       label: "Accounts",
//     },
//     {
//       id: "voucher",
//       label: "Voucher",
//     },
//     // {
//     //   id: "production",
//     //   label: "Production",
//     // },
//   ];

//   navigator.browserDetection = (function () {
//     var ua = navigator.userAgent,
//       tem,
//       M =
//         ua.match(
//           /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
//         ) || [];
//     if (/trident/i.test(M[1])) {
//       tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
//       return "IE " + (tem[1] || "");
//     }
//     if (M[1] === "Chrome") {
//       tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
//       if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
//     }
//     M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
//     if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
//     return M.join(" ");
//   })();

//   // //console.log(navigator.browserDetection); // outputs: `Chrome 92`
//   const browserName = navigator.browserDetection.replace(/[0-9 ]/g, "");

//   function getOS() {
//     var userAgent = window.navigator.userAgent,
//       platform = window.navigator.platform,
//       macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
//       windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
//       iosPlatforms = ["iPhone", "iPad", "iPod"],
//       os = null;

//     if (macosPlatforms.indexOf(platform) !== -1) {
//       os = "Mac OS";
//     } else if (iosPlatforms.indexOf(platform) !== -1) {
//       os = "iOS";
//     } else if (windowsPlatforms.indexOf(platform) !== -1) {
//       os = "Windows";
//     } else if (/Android/.test(userAgent)) {
//       os = "Android";
//     } else if (!os && /Linux/.test(platform)) {
//       os = "Linux";
//     }

//     return os;
//   }

//   const operatinySystem = getOS();

//   useEffect(() => {
//     getIPInfo();
//   }, []);

//   const getIPInfo = () => {
//     fetch("https://ipapi.co/json/")
//       .then((res) => res.json())
//       .then((result) => {
//         setIPInfo(result);
//       });
//   };

//   const checkLogin = async () => {
//     try {
//       const payload = {
//         managerId,
//         deviceId,
//         ip: iPInfo?.ip,
//         browser: browserName,
//         os: operatinySystem,
//         city: iPInfo?.city,
//         state: iPInfo?.region,
//         country: iPInfo?.country_name,
//         // ip: iPInfo?.ip || "192.168.1.6",
//         // browser: browserName || "chrome",
//         // os: operatinySystem || "window",
//         // city: iPInfo?.city || "lucknow",
//         // state: iPInfo?.region || "uttar pradesh",
//         // country: iPInfo?.country_name || "india",
//       };
//       // console.log("CHECK LOGIN RESPONSE:", payload);

//       const res = await fetchData("admin/checklogin", payload);

//       // console.log("CHECK LOGIN RESPONSE:", res);

//       if (res?.status === "success") {
//         show(res?.msg);
//         setOtpAcToken(res?.actoken);
//       }
//     } catch (error) {
//       console.log("CHECK LOGIN ERROR:", error);
//     }
//   };

//   useEffect(() => {
//     if (!managerId || !deviceId || !iPInfo) return;
//     checkLogin();
//   }, [managerId, deviceId, iPInfo]);

//   // useEffect(() => {
//   //   if (!managerId || !deviceId) return;
//   //   checkLogin();
//   // }, [managerId, deviceId]);

//   // VERIFY SUCCESS
//   const handleVerifySuccess = (token) => {
//     // console.log("OTP VERIFIED TOKEN:", token);
//     setOtpAcToken(token);
//     setIsVerified(true);
//   };

//   // CLOSE MODAL

//   const handleCloseModal = () => {
//     navigate("/dashboard");
//   };

//   // OTP MODAL SCREEN

//   if (!isVerified) {
//     return (
//       <div className={styles.otpPageWrapper}>
//         {/* OVERLAY */}

//         <div className={styles.otpOverlay}>
//           {/* MODAL */}

//           <div className={styles.otpModal}>
//             <SettingsOtpVfy
//               mode={mode}
//               managerId={managerId}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//               onVerify={handleVerifySuccess}
//               onClose={handleCloseModal}
//               show={show}
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // MAIN SETTINGS UI

//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       {/* TOP BAR */}
//       <div className={styles.topBar}>
//         <div>
//           <TopTabBar text={"Settings"} />
//         </div>
//         {/* TABS */}
//         <div className={styles.mainTab}>
//           <div className={styles.tabBar}>
//             {TABS.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`${styles.tabBtn} ${
//                   activeTab === tab.id ? styles.tabBtnActive : ""
//                 }`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* CONTENT */}
//       {loading && otpActoken ? (
//         <div className={styles.loaderBox}>Loading...</div>
//       ) : (
//         <>
//           {activeTab === "company" && (
//             <Company
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//             />
//           )}

//           {activeTab === "accounts" && (
//             <Accounts
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//               mode={mode}
//               managerId={managerId}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//               show={show}
//             />
//           )}

//           {activeTab === "voucher" && (
//             <Voucher otpActoken={otpActoken} setOtpAcToken={setOtpAcToken} />
//           )}

//           {activeTab === "production" && (
//             <Production otpActoken={otpActoken} setOtpAcToken={setOtpAcToken} />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Settings;

// -----------------------permission first for call api check login and ipinfo settings -----------------------------
import React, { useState } from "react";

import styles from "./Settings.module.css";

import { useNavigate } from "react-router-dom";

import { useAuth } from "../../components/context/Auth";

import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";

import Company from "./Company";
import Accounts from "./Accounts";
import Voucher from "./Voucher";

import SettingsOtpVfy from "../../components/updatedComponents/Settings/SettingsOtpVfy";
import fetchData from "../../APIsControll/apiControll";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";

// ─────────────────────────────────────────
// STEP ENUM
// ─────────────────────────────────────────
const STEP = {
  CONFIRM: "confirm", // ← first screen: "Are you sure?"
  LOADING: "loading", // ← calling getIPInfo + checkLogin
  OTP: "otp", // ← OTP verification
  MAIN: "main", // ← settings UI
};

const Settings = () => {
  const { mode, managerId } = useAuth();
  const deviceId = localStorage.getItem("UnDeviceId");
  const { show } = useToast();
  const navigate = useNavigate();

  const [step, setStep] = useState(STEP.CONFIRM);
  // -----for Test--------
  // const [step, setStep] = useState(STEP.MAIN);

  const [activeTab, setActiveTab] = useState("company");
  const [otpActoken, setOtpAcToken] = useState("");
  const [iPInfo, setIPInfo] = useState(null);

  // ── TABS ────────────────────────────────
  const TABS = [
    { id: "company", label: "Company" },
    { id: "accounts", label: "Accounts" },
    { id: "voucher", label: "Voucher" },
  ];

  // ── BROWSER DETECTION ───────────────────
  navigator.browserDetection = (function () {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  })();

  const browserName = navigator.browserDetection.replace(/[0-9 ]/g, "");

  // ── OS DETECTION ────────────────────────
  function getOS() {
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
      windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
      iosPlatforms = ["iPhone", "iPad", "iPod"],
      os = null;
    if (macosPlatforms.indexOf(platform) !== -1) os = "Mac OS";
    else if (iosPlatforms.indexOf(platform) !== -1) os = "iOS";
    else if (windowsPlatforms.indexOf(platform) !== -1) os = "Windows";
    else if (/Android/.test(userAgent)) os = "Android";
    else if (!os && /Linux/.test(platform)) os = "Linux";
    return os;
  }
  const operatinySystem = getOS();

  // ── GET IP INFO ─────────────────────────
  // Called ONLY after user clicks "Yes, Proceed"
  const getIPInfo = async () => {
    const res = await fetch("https://ipapi.co/json/");
    const result = await res.json();
    setIPInfo(result);
    return result;
  };

  // ── CHECK LOGIN ─────────────────────────
  // Called ONLY after IP info is fetched
  const checkLogin = async (ipData) => {
    try {
      const payload = {
        managerId,
        deviceId,
        ip: ipData?.ip,
        browser: browserName,
        os: operatinySystem,
        city: ipData?.city,
        state: ipData?.region,
        country: ipData?.country_name,
      };

      const res = await fetchData("admin/checklogin", payload);

      if (res?.status === "success") {
        show(res?.msg);
        setOtpAcToken(res?.actoken);
        setStep(STEP.OTP);
      } else {
        show(res?.msg || "Login check failed. Please try again.");
        setStep(STEP.CONFIRM);
      }
    } catch (error) {
      console.log("CHECK LOGIN ERROR:", error);
      show("Something went wrong. Please try again.");
      setStep(STEP.CONFIRM);
    }
  };

  // ── USER CLICKS "YES, PROCEED" ──────────
  // Only here do the APIs get called
  const handleConfirm = async () => {
    setStep(STEP.LOADING);
    try {
      const ipData = await getIPInfo(); // step 1: get IP
      await checkLogin(ipData); // step 2: check login
    } catch (err) {
      console.log("CONFIRM ERROR:", err);
      show("Failed to connect. Please try again.");
      setStep(STEP.CONFIRM);
    }
  };

  // ── USER CLICKS "NO, GO BACK" ───────────
  const handleCancel = () => {
    navigate("/dashboard");
  };

  // ── OTP VERIFIED ────────────────────────
  const handleVerifySuccess = (token) => {
    setOtpAcToken(token);
    setStep(STEP.MAIN);
  };

  // ── OTP MODAL CLOSE ─────────────────────
  const handleCloseModal = () => {
    navigate("/dashboard");
  };

  // ════════════════════════════════════════
  // RENDER
  // ════════════════════════════════════════

  // 1️⃣  CONFIRMATION POPUP — zero API calls
  if (step === STEP.CONFIRM) {
    return (
      <div className={styles.otpPageWrapper}>
        <div className={styles.otpOverlay}>
          <div
            className={`${styles.confirmModal} ${mode ? styles.dark : styles.light}`}
          >
            {/* Icon */}
            <div className={styles.confirmIconWrap}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={styles.confirmIcon}
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            {/* Text */}
            <h2 className={styles.confirmTitle}>Access Settings?</h2>
            <p className={styles.confirmSubtitle}>
              This area contains sensitive configuration. Your identity will be
              verified with a one-time password before you can proceed.
            </p>

            {/* Buttons */}
            <div className={styles.confirmActions}>
              <button
                className={styles.confirmCancelBtn}
                onClick={handleCancel}
              >
                No, Go Back
              </button>
              <button
                className={styles.confirmProceedBtn}
                onClick={handleConfirm}
              >
                Yes, Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // 2️⃣  LOADING — getIPInfo + checkLogin running
  if (step === STEP.LOADING) {
    return (
      <div className={styles.otpPageWrapper}>
        <div className={styles.otpOverlay}>
          <div
            className={`${styles.confirmModal} ${mode ? styles.dark : styles.light}`}
          >
            <div className={styles.loadingSpinnerWrap}>
              <div className={styles.loadingSpinner} />
            </div>
            <p className={styles.loadingText}>Please wait…</p>
          </div>
        </div>
      </div>
    );
  }

  // 3️⃣  OTP VERIFICATION
  if (step === STEP.OTP) {
    return (
      <div className={styles.otpPageWrapper}>
        <div className={styles.otpOverlay}>
          <div className={styles.otpModal}>
            <SettingsOtpVfy
              mode={mode}
              managerId={managerId}
              deviceId={deviceId}
              iPInfo={iPInfo}
              browserName={browserName}
              operatinySystem={operatinySystem}
              onVerify={handleVerifySuccess}
              onClose={handleCloseModal}
              show={show}
              otpActoken={otpActoken}
              setOtpAcToken={setOtpAcToken}
            />
          </div>
        </div>
      </div>
    );
  }

  // 4️⃣  MAIN SETTINGS UI
  return (
    <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
      {/* TOP BAR */}
      <div className={styles.topBar}>
        <div>
          <TopTabBar text={"Settings"} />
        </div>
        <div className={styles.mainTab}>
          <div className={styles.tabBar}>
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`${styles.tabBtn} ${activeTab === tab.id ? styles.tabBtnActive : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <>
        {activeTab === "company" && (
          <Company
            otpActoken={otpActoken}
            setOtpAcToken={setOtpAcToken}
            deviceId={deviceId}
            iPInfo={iPInfo}
            browserName={browserName}
            operatinySystem={operatinySystem}
          />
        )}
        {activeTab === "accounts" && (
          <Accounts
            otpActoken={otpActoken}
            setOtpAcToken={setOtpAcToken}
            mode={mode}
            managerId={managerId}
            deviceId={deviceId}
            iPInfo={iPInfo}
            browserName={browserName}
            operatinySystem={operatinySystem}
            show={show}
          />
        )}
        {activeTab === "voucher" && (
          <Voucher
            otpActoken={otpActoken}
            setOtpAcToken={setOtpAcToken}
            managerId={managerId}
            deviceId={deviceId}
            iPInfo={iPInfo}
            browserName={browserName}
            operatinySystem={operatinySystem}
            show={show}
          />
        )}
      </>
    </div>
  );
};

export default Settings;

// ----------------------- for token save  -----------------------------

// import React, { useEffect, useState } from "react";

// import styles from "./Settings.module.css";

// import { useNavigate } from "react-router-dom";

// import { useAuth } from "../../components/context/Auth";

// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";

// import Company from "./Company";
// import Accounts from "./Accounts";
// import Voucher from "./Voucher";
// import Production from "./Production";

// import SettingsOtpVfy from "../../components/updatedComponents/Settings/SettingsOtpVfy";
// import fetchData from "../../APIsControll/apiControll";
// // import useDeviceInfo from "../../components/updatedComponents/Hooks/GetdeviceId";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";

// const Settings = () => {
//   const { mode, managerId } = useAuth();
//   const deviceId = localStorage.getItem("UnDeviceId");
//   const { show } = useToast();
//   const navigate = useNavigate();

//   const [activeTab, setActiveTab] = useState("company");

//   const [isVerified, setIsVerified] = useState(false);

//   const [otpActoken, setOtpAcToken] = useState("");

//   const [loading, setLoading] = useState(false);
//   const [iPInfo, setIPInfo] = useState("");

//   // TABS

//   const TABS = [
//     {
//       id: "company",
//       label: "Company",
//     },
//     {
//       id: "accounts",
//       label: "Accounts",
//     },
//     {
//       id: "voucher",
//       label: "Voucher",
//     },
//     // {
//     //   id: "production",
//     //   label: "Production",
//     // },
//   ];

//   navigator.browserDetection = (function () {
//     var ua = navigator.userAgent,
//       tem,
//       M =
//         ua.match(
//           /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i,
//         ) || [];
//     if (/trident/i.test(M[1])) {
//       tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
//       return "IE " + (tem[1] || "");
//     }
//     if (M[1] === "Chrome") {
//       tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
//       if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
//     }
//     M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
//     if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
//     return M.join(" ");
//   })();

//   // //console.log(navigator.browserDetection); // outputs: `Chrome 92`
//   const browserName = navigator.browserDetection.replace(/[0-9 ]/g, "");

//   function getOS() {
//     var userAgent = window.navigator.userAgent,
//       platform = window.navigator.platform,
//       macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
//       windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
//       iosPlatforms = ["iPhone", "iPad", "iPod"],
//       os = null;

//     if (macosPlatforms.indexOf(platform) !== -1) {
//       os = "Mac OS";
//     } else if (iosPlatforms.indexOf(platform) !== -1) {
//       os = "iOS";
//     } else if (windowsPlatforms.indexOf(platform) !== -1) {
//       os = "Windows";
//     } else if (/Android/.test(userAgent)) {
//       os = "Android";
//     } else if (!os && /Linux/.test(platform)) {
//       os = "Linux";
//     }

//     return os;
//   }

//   const operatinySystem = getOS();

//   useEffect(() => {
//     getIPInfo();
//   }, []);

//   const getIPInfo = () => {
//     fetch("https://ipapi.co/json/")
//       .then((res) => res.json())
//       .then((result) => {
//         setIPInfo(result);
//       });
//   };

//   const checkLogin = async () => {
//     try {
//       const payload = {
//         managerId,
//         deviceId,
//         ip: iPInfo?.ip,
//         browser: browserName,
//         os: operatinySystem,
//         city: iPInfo?.city,
//         state: iPInfo?.region,
//         country: iPInfo?.country_name,
//         // ip: iPInfo?.ip || "192.168.1.6",
//         // browser: browserName || "chrome",
//         // os: operatinySystem || "window",
//         // city: iPInfo?.city || "lucknow",
//         // state: iPInfo?.region || "uttar pradesh",
//         // country: iPInfo?.country_name || "india",
//       };
//       // console.log("CHECK LOGIN RESPONSE:", payload);

//       const res = await fetchData("admin/checklogin", payload);

//       // console.log("CHECK LOGIN RESPONSE:", res);

//       if (res?.status === "success") {
//         show(res?.msg);
//         setOtpAcToken(res?.actoken);
//       }
//     } catch (error) {
//       console.log("CHECK LOGIN ERROR:", error);
//     }
//   };

//   useEffect(() => {
//     if (!managerId || !deviceId || !iPInfo) return;
//     checkLogin();
//   }, [managerId, deviceId, iPInfo]);

//   // useEffect(() => {
//   //   if (!managerId || !deviceId) return;
//   //   checkLogin();
//   // }, [managerId, deviceId]);

//   // VERIFY SUCCESS
//   // const handleVerifySuccess = (token) => {
//   //   // console.log("OTP VERIFIED TOKEN:", token);
//   //   setOtpAcToken(token);
//   //   setIsVerified(true);
//   // };

//   //------  VERIFY SUCCESS for token save in local Storage

//   const handleVerifySuccess = (token) => {
//     const expiryTime = Date.now() + 15 * 60 * 1000; // 5 min

//     localStorage.setItem(
//       "settingsOtp",
//       JSON.stringify({
//         token,
//         expiryTime,
//       }),
//     );

//     setOtpAcToken(token);
//     setIsVerified(true);
//   };

//   useEffect(() => {
//     const savedOtp = localStorage.getItem("settingsOtp");

//     if (!savedOtp) {
//       setIsVerified(false);
//       return;
//     }

//     const { token, expiryTime } = JSON.parse(savedOtp);

//     if (Date.now() < expiryTime) {
//       setOtpAcToken(token);
//       setIsVerified(true);
//     } else {
//       localStorage.removeItem("settingsOtp");
//       setIsVerified(false);
//     }
//   }, []);

//   // ------ OPTIONAL LOGOUT--------
//   useEffect(() => {
//     if (!otpActoken) return;

//     const timer = setTimeout(
//       () => {
//         localStorage.removeItem("settingsOtp");
//         setOtpAcToken("");
//         setIsVerified(false);
//       },
//       15 * 60 * 1000,
//     );

//     return () => clearTimeout(timer);
//   }, [otpActoken]);

//   // -------------------------------------------------------

//   // CLOSE MODAL

//   const handleCloseModal = () => {
//     navigate("/dashboard");
//   };

//   // OTP MODAL SCREEN

//   if (!isVerified) {
//     return (
//       <div className={styles.otpPageWrapper}>
//         {/* OVERLAY */}

//         <div className={styles.otpOverlay}>
//           {/* MODAL */}

//           <div className={styles.otpModal}>
//             <SettingsOtpVfy
//               mode={mode}
//               managerId={managerId}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//               onVerify={handleVerifySuccess}
//               onClose={handleCloseModal}
//               show={show}
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // MAIN SETTINGS UI

//   return (
//     <div className={`${styles.root} ${mode ? styles.dark : styles.light}`}>
//       {/* TOP BAR */}
//       <div className={styles.topBar}>
//         <div>
//           <TopTabBar text={"Settings"} />
//         </div>
//         {/* TABS */}
//         <div className={styles.mainTab}>
//           <div className={styles.tabBar}>
//             {TABS.map((tab) => (
//               <button
//                 key={tab.id}
//                 className={`${styles.tabBtn} ${
//                   activeTab === tab.id ? styles.tabBtnActive : ""
//                 }`}
//                 onClick={() => setActiveTab(tab.id)}
//               >
//                 {tab.label}
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* CONTENT */}
//       {loading && otpActoken ? (
//         <div className={styles.loaderBox}>Loading...</div>
//       ) : (
//         <>
//           {activeTab === "company" && (
//             <Company
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//             />
//           )}

//           {activeTab === "accounts" && (
//             <Accounts
//               otpActoken={otpActoken}
//               setOtpAcToken={setOtpAcToken}
//               mode={mode}
//               managerId={managerId}
//               deviceId={deviceId}
//               iPInfo={iPInfo}
//               browserName={browserName}
//               operatinySystem={operatinySystem}
//               show={show}
//             />
//           )}

//           {activeTab === "voucher" && (
//             <Voucher otpActoken={otpActoken} setOtpAcToken={setOtpAcToken} />
//           )}

//           {activeTab === "production" && (
//             <Production otpActoken={otpActoken} setOtpAcToken={setOtpAcToken} />
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Settings;
